import React from 'react';
import Header from '../components/layout/Header';
import HeroSection from '../components/common/HeroSection';
import FeaturesSection from '../components/common/FeaturesSection';
import SubscriptionPlansSection from '../components/common/SubscriptionPlansSection';
import ContactSection from '../components/common/ContactSection';
import Footer from '../components/layout/Footer';
import usePageTitle from '../hooks/usePageTitle';

const HomePage = () => {
  // Set empty title for landing page (no brand name in tab)
  usePageTitle('', false);

  return (
    <>
      <Header />
      <main className="w-full">
        <HeroSection />
        <FeaturesSection />
        <SubscriptionPlansSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
